import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    align-items: center;\n    box-sizing: border-box;\n    display: flex;\n    height: 64px;\n    margin: 0;\n\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Typography } from '../../Typography';
import { getPropsBlocker } from '../../../utils';

var footerStyle = function footerStyle(_ref) {
  var theme = _ref.theme;

  var _a;

  var SideSheet = (_a = theme === null || theme === void 0 ? void 0 : theme.componentOverrides) === null || _a === void 0 ? void 0 : _a.SideSheet;
  return SideSheet.Footer.base;
};

export var SideSheetFooter = styled(Typography).withConfig(getPropsBlocker({}, false))(_templateObject(), footerStyle);